// extracted by mini-css-extract-plugin
module.exports = {"avatar":"UserAvatar_avatar__7H-OK","image":"UserAvatar_image__2sGmh"};